/** Backslash or a control character, by char code. */
const isUnsafeChar = (char: string) => {
	const code = char.charCodeAt(0);
	return char === "\\" || code < 0x20 || code === 0x7f;
};

/**
 * The `?redirect=` target after login, or null when it is missing or could
 * leave the site. Only same-origin paths are accepted.
 */
export const loginRedirectPath = (value: unknown): string | null => {
	if (typeof value !== "string" || !value.startsWith("/")) return null;
	// Browsers read "\" as "/" and drop tabs and newlines, so "/\t/evil.example" is "//evil.example".
	if (value.startsWith("//") || [...value].some(isUnsafeChar)) return null;
	return value;
};
